import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../../components/static home/static_home.css";
import Slider from "../../components/static home/Slider";
import About from "../../components/static home/About";
import Why from "../../components/static home/Why";
import MarketerSolution from "../../components/static home/MarketerSolution";
import Header from "../../components/static home/Header";
import SupplierSolution from "../../components/static home/SupplierSolution";
import Where from "../../components/static home/Where";
import CommonQuestions from "../../components/static home/CommonQuestions";
import Says from "../../components/static home/Says";
import Footer from "../../components/static home/Footer";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import { Whatsapp } from "../../components/static home/Whatsapp";

export const StaticHome = () => {
  const [isSticky, setIsSticky] = useState(false);
  const { i18n, t: _ } = useTranslation("global");
  const { lang } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (lang && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
    // Redirect if lang is not 'ar' or 'en'
    if (lang && lang !== "ar" && lang !== "en") {
      navigate("/ar", { replace: true });
    }
  }, [lang, i18n, navigate]);

  useEffect(() => {
    AOS.init({
      duration: 800,
      offset: 10,
      once: true,
      easing: "ease-in-out",
    });

    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lang]);

  return (
    <div dir={lang === "en" ? "ltr" : "rtl"} style={{ overflow: "hidden" }}>
      {/* Header Section with Metadata */}
      <header>
        <Helmet>
          <title>{_("static_home.title")}</title>
          <meta name="description" content={_("static_home.description")} />
          <meta name="keywords" content={_("static_home.keywords")} />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta name="robots" content="index, follow" />
          <meta property="og:title" content={_("static_home.title")} />
          <meta
            property="og:description"
            content={_("static_home.description")}
          />
          <meta property="og:type" content="website" />
        </Helmet>
        <Header
          navItems={[
            { labelKey: "static_home.header.about", href: "#about" },
            { labelKey: "static_home.header.why", href: "#why" },
            { labelKey: "static_home.header.where", href: "#where" },
            {
              labelKey: "static_home.header.marketerSolution",
              href: "#marketerSolution",
            },
            {
              labelKey: "static_home.header.supplierSolution",
              href: "#supplierSolution",
            },
            {
              labelKey: "static_home.header.commonQuestions",
              href: "#common-questions",
            },
          ]}
          isSticky={isSticky}
        />
      </header>

      {/* Main Body Section */}
      <main>
        <Slider 
          title={_("static_home.slider.title")}
          description={_("static_home.slider.description")}
          join_us={_("static_home.slider.join_us")}
          subheader={_("static_home.slider.subheader")}
          subheaderTitle={_("static_home.slider.subheader.title")}
          subheaderSubtitle={_("static_home.slider.subheader.subtitle")}
          subheaderDescription={_("static_home.slider.subheader.description")}
        />
        <div className="static-home-about">
          <About text={_("static_home.about.description")} />
        </div>
        <div className="static-home-why">
          <Why
            title={_("static_home.why.title")}
            description={_("static_home.why.description")}
            type="static_home"
            conclusion={_("static_home.why.conclusion")}
          />
        </div>
        <div className="static-home-solution">
          <MarketerSolution />
        </div>
        <div className="static-home-solution">
          <SupplierSolution />
        </div>
        <div className="static-home-where">
          <Where />
        </div>
        <div className="static-home-questions">
          <CommonQuestions type="static_home" />
        </div>
        <div className="static-home-says">
          <Says />
        </div>
        <Whatsapp />
      </main>

      {/* Footer Section */}
      <footer>
        <Footer />
      </footer>
    </div>
  );
};
